import { Link } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { Logo } from "@/components/landing/Logo";

const DOWNLOAD_URL = `${process.env.REACT_APP_BACKEND_URL}/api/download/project`;

export default function DownloadPage() {
  return (
    <div className="flex min-h-screen flex-col bg-[#f5f5ee] text-[#292929]" data-testid="download-page">
      <header className="mx-auto flex h-16 w-full max-w-[1360px] items-center px-5 sm:px-8">
        <Link to="/" aria-label="Condoor home" data-testid="download-logo-link"><Logo className="h-7 sm:h-8" testId="download-logo" /></Link>
      </header>
      <main className="mx-auto flex w-full max-w-[1360px] flex-1 flex-col justify-center px-5 pb-24 sm:px-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#ff6600]">Source code</p>
        <h1 className="mt-4 max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-[-0.035em] sm:text-5xl" data-testid="download-title">
          Download the Condoor project
        </h1>
        <p className="mt-5 max-w-xl text-base text-[#55554f]" data-testid="download-note">
          React frontend, FastAPI backend, product docs and a README with local setup steps. No dependencies or secrets included.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-6">
          <a href={DOWNLOAD_URL} download="condoor.zip" className="cd-btn-primary inline-flex h-12 items-center gap-2 px-6 text-sm" data-testid="download-project-button">
            <Download className="h-4 w-4" /> Download project (.zip)
          </a>
          <Link to="/" className="cd-navlink inline-flex items-center gap-1.5 text-sm text-[#292929]" data-testid="download-back-home-link">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </main>
    </div>
  );
}
